/**
 * @name storage
 * @description
 * Work with localstorage quickly and with expiration mode to items
 */
export default class Storage {

    constructor() {

        // Instance configuration
        this.config = {
            expireUnit: 60000, // Minutes to Miliseconds
            cacheSufix: '-cacheExpiration'
        };
    }

    /**
     * Returns the full string for the localStorage expiration item.
     * @param {String} key
     * @return {string}
     */
    expirationKey(key) {
        return key + this.config.cacheSufix;
    }

    /**
     * Returns the number of minutes since the epoch.
     * @return {number}
     */
    currentTime() {
        return new Date().getTime();
    }

    /**
     * @description
     * Method to get a item
     * @param {string} name Name of item to get
     */
    getItem(name) {
        // Get cache of item
        const exprkey = localStorage.getItem(this.expirationKey(name));

        // Check cache timeout of item
        if (exprkey && this.currentTime() >= parseInt(exprkey)) {
            localStorage.removeItem(name);
            localStorage.removeItem(this.expirationKey(name));
            return null;
        } else {
            try {
                return JSON.parse(localStorage.getItem(name));
            } catch (err) {
                return localStorage.getItem(name) || null;
            }
        }
    }

    /**
     * @description
     * Method to get the date of item expiration
     * @param {string} name Name of item
     */
    getItemExpiration(name) {
        // Get cache of item
        return localStorage.getItem(this.expirationKey(name));
    }

    /**
     * @description
     * Method to save a item
     * @param {string} name Name to save the item
     * @param {object} object Object to save
     * @param {string} item Time to save the item (in minutes)
     */
    setItem(name, object, time) {
        localStorage.setItem(name, typeof object === 'object' ? JSON.stringify(object) : object);
        if (time) localStorage.setItem(this.expirationKey(name), (this.currentTime() + (time * this.config.expireUnit)).toString());
    }

    /**
     * @description
     * Add object to exist item
     * @param {string} name Name to item save
     * @param {string} index Index to save the object
     * @param {object} object Onject to save
     */
    addItem(name, index, object) {

        // Create item
        let item = this.getItem(name) || {};

        // Add element
        if (!item[index]) {
            item[index] = object;
            localStorage.setItem(name, JSON.stringify(item));
        }
    }

    /**
     * @description
     * Method to edit a item
     * @param {string} name Name of object to edit
     * @param {string} prop Attribute to edit
     * @param {string} value Value to update
     */
    updateItem(name, prop, value) {
        let obj = JSON.parse(localStorage.getItem(name));
        obj[prop] = value;

        localStorage.setItem(name, JSON.stringify(obj));
    }

    /**
     * @description
     * Method to remove a item
     * @param {string} name Name of item to remove
     */
    deleteItem(name) {
        localStorage.removeItem(name);
        if (localStorage.getItem(this.expirationKey(name))) localStorage.removeItem(this.expirationKey(name));
    }

    /**
     * @description
     * Method to remove all items
     */
    clear() {
        localStorage.clear();
    }
}